import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var PickPipe = (function () {
    function PickPipe() {
    }
    PickPipe.prototype.transform = function (obj) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return args.reduce(function (o, k) {
            return Object.assign(o, (_a = {}, _a[k] = obj[k], _a));
            var _a;
        }, {});
    };
    PickPipe.decorators = [
        { type: Pipe, args: [{ name: 'pick' },] },
    ];
    /** @nocollapse */
    PickPipe.ctorParameters = function () { return []; };
    return PickPipe;
}());
export { PickPipe };
//# sourceMappingURL=pick.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/pick.js
// module id = 275
// module chunks = 4